export const concatIds = (target, add) =>
  target.filter((item) => !add.some((i) => item === i)).concat(add)
